





















import { Component, Vue, Prop } from "vue-property-decorator";

/**
 * Utils
 */

/**
 * Helpers
 */

/**
 * Mixins
 */

/**
 * Components
 */
import Dialog from "@/components/_global/Dialog.vue";

/**
 * API
 */
import teamsAPI from "@/api/teams";

/**
 * Delete character modal.
 */
@Component
export default class LeaveTeamDialog extends Vue {
	$refs!: {
		modal: Dialog;
	};

	/// Injections

	/// Properties
	@Prop()
	onAfterLeave!: () => Promise<void>;

	/// Attributes
	isLoading = false;
	team: any | null = null;

	/// Methods
	async open(team: any) {
		this.$refs.modal.open();
		this.team = team;
	}

	close() {
		this.$refs.modal.close();
	}

	async handleLeaveTeamClick() {
		this.isLoading = true;
		try {
			await teamsAPI.leaveTeam(this.team.id);
			this.close();
			if (this.onAfterLeave) {
				await this.onAfterLeave();
			}
		}
		catch (error) {
			this.handleAPIError(error);
		}
		this.isLoading = false;
	}
}
